import { TFunction } from "i18next";
import * as Yup from "yup";

export const getRoleFormSchema = (t: TFunction, currentLang: string) => {
    const optionalString = Yup.string()
        .transform((value) => (value === '' ? undefined : value))
        .notRequired();
    return Yup.object().shape({
        description: Yup.object().shape({
            catalan: currentLang === "ca"
                ? Yup.string().trim().required(t("common:form.requiredFieldForm"))
                : optionalString,
            english: currentLang === "en"
                ? Yup.string().trim().required(t("common:form.requiredFieldForm"))
                : optionalString,
            french: currentLang === "fr"
                ? Yup.string().trim().required(t("common:form.requiredFieldForm"))
                : optionalString,
            spanish: currentLang === "es"
                ? Yup.string().trim().required(t("common:form.requiredFieldForm"))
                : optionalString,
        }),
        validityDate: Yup.date()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidDateForm")),
        id: Yup.number()
            .required(t("common:form.requiredFieldForm"))
            .typeError(t("common:form.invalidNumberForm")),
        rolePermissions: Yup.array()
            .min(1, t("role:form.atLeastOnePermissionRequired"))
            .required(t("common:form.requiredFieldForm")),
    });
};